import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User, PagedUsers } from '../models/users.model';
import { environment } from 'src/environments/environment';
import { of } from 'rxjs';


@Injectable({
    providedIn: 'root'
    })
export class UsersServerService {
    private url = `${environment.apiUrl}/users`;

    constructor(private http: HttpClient) {}

    getUsers(page: number, limit: number, query?: string): Observable<PagedUsers> {
        let queryString = `page=${page}&limit=${limit}`;
        if (query) {
            queryString += `&search=${query}`;
        }
        return this.http.get<PagedUsers>(`${this.url}?${queryString}`);
    }

    getUserById(id: number): Observable<User> {
        return this.http.get<User>(`${this.url}/${id}`);
    }

    createUser(user: User): Observable<User> {
        return this.http.post<User>(this.url, user);
    }

    editUser(user: User): Observable<User> {
        const url = `${this.url}/${user.id}`;
        return this.http.put<User>(url, user);
    }

    deleteUser(id: string): Observable<User> {
        const url = `${this.url}/${id}`;
        return this.http.delete<User>(url);
    }

    searchUsers(page: number, limit: number, query: string): Observable<PagedUsers> {
        return this.http.get<PagedUsers>(`${this.url}?page=${page}&limit=${limit}&search=${query}`);
    }

}